import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core'

import { PlayerListenerComponentDirective } from '../../../base-component/player-listener.component'
import { ICartTrack, ITrack } from '../../../Interface/track'
import { PlayerLogic } from '../../../player/AngPlayer'
import { CartService } from '../../../services/cart.service'
import { RoutingPathService } from '../../../services/environment.service'
import { CurrencySignType, I18nService, LgType } from '../../../services/prod/i18n.service'
import { TrackInCartService } from '../../../services/track-in-cart.service'
import { AppType } from '../../../types/app.type'

@Component({
  selector: 'bmcore-track-item',
  templateUrl: './bmcore-track-item.component.html',
  styleUrls: ['./bmcore-track-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackItemComponent extends PlayerListenerComponentDirective<ITrack> implements OnInit {
  @Input() track: ICartTrack
  @Input() isShowFavBtn: boolean
  @Input() isTrackInCart: boolean
  @Input() isTopSeller = false
  @Input() appType: AppType
  @Input() ordinalNumber: number

  @Input() showVerificationIcon = false

  @Output() setPlaylistEvent = new EventEmitter()

  lg: LgType
  currencySign: CurrencySignType
  checkoutPage: string
  isCurrentTrackInCart: boolean

  constructor(
    public player: PlayerLogic,
    protected cartService: CartService,
    public trackInCartService: TrackInCartService,
    private i18nService: I18nService,
    private renderer: Renderer2,
    private routingPathService: RoutingPathService
  ) {
    super(player, cartService)
    this.checkoutPage = this.routingPathService.getCheckoutUrl()
  }

  ngOnInit() {
    this.currencySign = this.i18nService.getCurrencySign()
    this.lg = this.i18nService.getLanguageForPage()
    this.updateIsTrackInCart()

    this.cartService.addSubscriber('group-updated', () => {
      this.updateIsTrackInCart()
    })
  }

  private updateIsTrackInCart() {
    if (this.track?.id != null) {
      this.isCurrentTrackInCart = this.trackInCartService.checkIsTrackInCart(this.track.id)
    }
  }

  playBeat(e: MouseEvent, track: ITrack) {
    // checks necessary to show the active track
    if (this.player.currentTrack?.id === track.id && this.player.currentTrack !== null) {
      this.onPlayPauseClick(e)
    } else {
      this.play(e, track)

      // TODO (excessive playlist setting): Remove commented setting of playlist if no bugs are found
      // this.setPlaylistEvent.emit()
    }
  }

  wantToAddBeat(event: MouseEvent, beatId: number) {
    event.stopPropagation()

    /* No parent scroll on modal scroll */
    /* https://stackoverflow.com/questions/9538868/prevent-body-from-scrolling-when-a-modal-is-opened */
    /* https://stackoverflow.com/questions/43542373/angular2-add-class-to-body-tag */
    this.renderer.addClass(document.body, 'modal-open')

    this.cartService.wantAddBeat(beatId)
  }
}
